{
  "panel": {
    "title": "Заметки",
    "newNote_title": "Новая заметка",
    "search_placeholder": "Поиск по заметкам…",
    "search_aria": "Поиск по заметкам",
    "clearSearch_aria": "Очистить поиск",
    "editorPlaceholder": "О чём вы думаете…",
    "titleInput_placeholder": "Без названия",
    "untitled": "Без названия",
    "emptyNote": "Пустая заметка",
    "loadingNotes": "Загрузка заметок…",
    "noNotesYet": "Заметок пока нет. Нажмите +, чтобы создать.",
    "noResults": "Нет результатов по запросу «{{query}}»",
    "noNotesTagged": "Нет заметок с тегом {{tag}}",
    "tagFilterAll": "Все",
    "filterByTag_aria": "Фильтр по тегу",
    "templates": "Шаблоны",
    "editorTheme_aria": "Тема редактора",
    "themeActive_aria": "Тема {{theme}} (активна)",
    "theme_aria": "Тема {{theme}}",
    "themeName": {
      "dark": "Тёмная",
      "sepia": "Сепия",
      "light": "Светлая",
      "forest": "Лесная"
    },
    "voice": "Голос",
    "voice_title": "Голосовая заметка",
    "voiceUnavailable_title": "Распознавание речи недоступно в этом браузере",
    "openVoiceRecorder_aria": "Открыть запись голосовой заметки",
    "summarizing_title": "Подведение итогов…",
    "summarize_title": "Подвести итог",
    "summarizeNote_aria": "Подвести итог заметки",
    "aiCommands_title": "Команды AI  Cmd+K",
    "openAiPalette_aria": "Открыть палитру команд AI",
    "enterFocusMode_title": "Режим фокуса  Cmd+Shift+F",
    "exitFocusMode_title": "Выйти из режима фокуса  Cmd+Shift+F",
    "enterFocusMode_aria": "Войти в режим фокуса",
    "exitFocusMode_aria": "Выйти из режима фокуса",
    "export_title": "Экспорт заметки",
    "delete_title": "Удалить заметку",
    "delete_aria": "Удалить заметку",
    "moreActions_title": "Ещё действия",
    "wordCount_one": "{{formatted}} слово · ~{{minutes}} мин чтения",
    "wordCount_other": "{{formatted}} слов · ~{{minutes}} мин чтения",
    "referencedBy_one": "Упоминается в {{count}}",
    "referencedBy_other": "Упоминается в {{count}}",
    "noMatchingNotes": "Нет подходящих заметок",
    "mobileTabs_aria": "Вид заметок",
    "mobileTabNotes": "Заметки",
    "mobileTabEditor": "Редактор",
    "saveFailed": "Не удалось сохранить заметку: {{message}}",
    "deleteFailed": "Не удалось удалить заметку",
    "loadFailed": "Не удалось загрузить заметки",
    "analyzeFailed": "Не удалось проанализировать заметку",
    "aiCommandFailed": "Команда AI не выполнена",
    "unknownError": "Неизвестная ошибка"
  },
  "paywall": {
    "title": "Заметки входят в Rhemn Pro",
    "safariBody": "Откройте синхронизированные заметки, диктовку и ИИ-сводки с Rhemn Pro. Уже подписаны? Доступ откроется автоматически после входа.",
    "body": "Откройте синхронизируемые заметки, диктовку в браузере и структурированные сводки AI."
  },
  "format": {
    "bold": "Жирный",
    "italic": "Курсив",
    "strikethrough": "Зачёркнутый",
    "inlineCode": "Встроенный код",
    "heading1": "Заголовок 1",
    "heading2": "Заголовок 2",
    "heading3": "Заголовок 3",
    "bulletList": "Маркированный список",
    "numberedList": "Нумерованный список",
    "blockquote": "Цитата",
    "codeBlock": "Блок кода",
    "toggleBold_aria": "Переключить жирный",
    "toggleItalic_aria": "Переключить курсив",
    "toggleStrikethrough_aria": "Переключить зачёркнутый",
    "toggleInlineCode_aria": "Переключить встроенный код",
    "toggleBulletList_aria": "Переключить маркированный список",
    "toggleNumberedList_aria": "Переключить нумерованный список",
    "toggleBlockquote_aria": "Переключить цитату",
    "formatOptions_aria": "Параметры форматирования"
  },
  "analysis": {
    "heading": "Сводка",
    "onDevice": "⚡ На устройстве",
    "onDevice_aria": "Обработано на устройстве",
    "applyToNote_title": "Применить к заметке",
    "applyToNote_aria": "Применить сводку к заметке",
    "summaryLabel": "Сводка",
    "keyPointsLabel": "Ключевые моменты",
    "noKeyPoints": "Для этой заметки ключевые моменты не найдены."
  },
  "export": {
    "markdown": "Экспорт в Markdown",
    "plainText": "Экспорт в простой текст",
    "pdf": "Экспорт в PDF",
    "allZip": "Экспортировать всё в ZIP",
    "label": "Экспорт"
  },
  "cmdk": {
    "dialog_aria": "Палитра команд AI",
    "input_placeholder": "Спросите AI или выполните команду…",
    "esc": "Esc",
    "back_aria": "Назад",
    "translateTo": "Перевести на",
    "language_placeholder": "Язык…",
    "aiActions": "Действия AI",
    "noCommandsMatch": "Нет команд по запросу «{{query}}»",
    "continue": {
      "label": "Продолжить писать",
      "description": "Продолжить с того места, где вы остановились"
    },
    "summarize": {
      "label": "Подвести итог выделенного",
      "description": "Свести к ключевым моментам"
    },
    "formal": {
      "label": "Сделать формальным",
      "description": "Поднять тон до делового"
    },
    "simplify": {
      "label": "Упростить",
      "description": "Короче и яснее"
    },
    "translate": {
      "label": "Перевести на…",
      "description": "Перевести на другой язык"
    },
    "expand": {
      "label": "Развернуть этот пункт",
      "description": "Развернуть выбранный пункт в текст"
    },
    "languages": {
      "Spanish": "Испанский",
      "Arabic": "Арабский",
      "French": "Французский",
      "German": "Немецкий",
      "Japanese": "Японский",
      "Portuguese": "Португальский"
    }
  },
  "templates": {
    "dialog_aria": "Выбор шаблона",
    "header": "Выберите шаблон",
    "builtInLabel": "Встроенные",
    "myTemplatesLabel": "Мои шаблоны",
    "saveCurrent": "Сохранить текущую заметку как шаблон",
    "myTemplatesEmpty": "Здесь появятся ваши сохранённые шаблоны",
    "useTemplate": "Использовать шаблон",
    "meeting": {
      "name": "Заметки встречи",
      "description": "Фиксируйте решения и задачи",
      "structure": "Участники / Повестка / Заметки / Действия"
    },
    "journal": {
      "name": "Ежедневный дневник",
      "description": "Поразмышляйте о своём дне",
      "structure": "Благодарность / Победы дня / Заметки"
    },
    "book": {
      "name": "Конспект книги",
      "description": "Зафиксируйте ключевые идеи из книги",
      "structure": "Главная идея / Ключевые цитаты / Выводы"
    },
    "project": {
      "name": "Бриф проекта",
      "description": "Опишите рамки, цели и заинтересованные стороны",
      "structure": "Цель / Рамки / Риски / Сроки"
    },
    "brainstorm": {
      "name": "Мозговой штурм",
      "description": "Свободная фиксация идей",
      "structure": "Тема / Идеи / Следующие шаги"
    },
    "weekly": {
      "name": "Обзор недели",
      "description": "Подведите итоги и спланируйте неделю",
      "structure": "Победы / Трудности / Зоны фокуса"
    }
  },
  "voice": {
    "dialog_aria": "Запись голосовой заметки",
    "cancel_aria": "Отмена",
    "statusRecording": "Запись",
    "statusTranscribing": "Расшифровка…",
    "statusReview": "Проверка",
    "skip": "Пропустить",
    "mark": "Метка",
    "mark_title": "Поставить метку времени",
    "captureMeeting": "Захватить встречу",
    "captureMeeting_title": "Также захватывать звук со вкладки встречи",
    "meeting": "Встреча",
    "meeting_title": "Захват вкладки встречи",
    "markers_aria": "Метки времени",
    "listening": "Слушаю…",
    "micDenied": "Доступ к микрофону отключён. Разрешите его в настройках и попробуйте снова.",
    "captureFailed": "Не удалось начать запись. Попробуйте снова через минуту.",
    "tabPicker_aria": "Выберите вкладку встречи для захвата",
    "captureFrom": "Захватить звук из…",
    "noAudibleTab": "Ни одна вкладка не воспроизводит звук. Откройте встречу и убедитесь, что кто-то говорит, затем попробуйте снова.",
    "tabPickerCancel": "Отмена",
    "tabTranscript": "Расшифровка",
    "structuring": "Структурирование…",
    "structuredNote": "Структурированная заметка",
    "structureFailed": "Не удалось создать структурированную заметку.",
    "retryStructure": "Повторить",
    "browserTranscript": "Расшифровка из браузера",
    "nothingCaptured": "Ничего не захвачено.",
    "buildingStructured": "Создание структурированной заметки…",
    "cancel": "Отмена",
    "stop": "Стоп",
    "recordAgain": "Записать снова",
    "saveToNote": "Сохранить в заметку",
    "statusMeeting": "Встреча",
    "captureStrip_aria": "Запись звука из {{tab}}",
    "stopCapture": "Остановить захват",
    "stopCapture_title": "Остановить захват вкладки — микрофон продолжит запись",
    "stopsIn": "Остановится через {{time}}",
    "autoStopped": "Запись остановлена на лимите в 60 минут.",
    "autoStoppedQuota": "Запись остановлена — минуты расшифровки за этот месяц израсходованы.",
    "captureLost": "Вкладка встречи закрылась. Микрофон всё ещё записывает.",
    "tabSummary": "Итоги",
    "noSpeakers": "Говорящие не определены",
    "speakerN": "Участник {{number}}",
    "renameSpeaker_aria": "Переименовать {{name}} — применится ко всем репликам",
    "renameSpeaker_input_aria": "Имя участника",
    "turnTime_title": "Сказано в {{time}}",
    "actionItemsTitle": "Задачи по итогам",
    "actionsCount": "{{checked}} из {{total}}",
    "addToTasks_one": "Добавить {{count}} в Задачи",
    "addToTasks_few": "Добавить {{count}} в Задачи",
    "addToTasks_many": "Добавить {{count}} в Задачи",
    "addToTasks_other": "Добавить {{count}} в Задачи",
    "addToTasksZero": "Добавить в Задачи",
    "adding": "Добавление…",
    "tasksAdded_one": "Добавлена {{count}} задача",
    "tasksAdded_few": "Добавлено {{count}} задачи",
    "tasksAdded_many": "Добавлено {{count}} задач",
    "tasksAdded_other": "Добавлено {{count}} задачи",
    "viewTasks": "Открыть",
    "addFailed": "Не удалось добавить — попробуйте ещё раз.",
    "minutesLeft_one": "Осталась {{count}} мин",
    "minutesLeft_few": "Осталось {{count}} мин",
    "minutesLeft_many": "Осталось {{count}} мин",
    "minutesLeft_other": "Осталось {{count}} мин",
    "minutesLeftShort_one": "Осталась {{count}} мин",
    "minutesLeftShort_few": "Осталось {{count}} мин",
    "minutesLeftShort_many": "Осталось {{count}} мин",
    "minutesLeftShort_other": "Осталось {{count}} мин",
    "minutesLeft_title": "Осталось {{count}} минут расшифровки в этом месяце",
    "quotaExhausted": "Минуты встреч за этот месяц израсходованы. Они обновятся {{date}}.",
    "quotaUnknown": "Остаток минут неизвестен — запись может упереться в месячный лимит",
    "meetingProRequired": "Расшифровка встреч входит в Pro. Ваша живая расшифровка сохранена ниже.",
    "gateTitle": "Запись встреч",
    "gateBody": "Записывайте вкладку встречи вместе с микрофоном — с определением говорящих и извлечением задач. Входит в Pro.",
    "gateLater": "Не сейчас",
    "gateCta": "Подробнее о Pro",
    "roomOption": "Без вкладки — записать комнату",
    "roomHint": "Звонок на громкой связи, отдельное приложение или люди в комнате — всё, что слышно вслух.",
    "roomHint_title": "Если собеседник у вас в наушниках, микрофон его не услышит — включите динамик.",
    "recordRoom": "Записать комнату",
    "recordRoom_title": "Записывает всех, кого слышит микрофон — с определением говорящих",
    "roomStart": "Начать",
    "statusRoom": "Комната",
    "roomStrip": "Идёт запись комнаты",
    "roomStrip_aria": "Идёт запись комнаты — всех, кого слышит микрофон",
    "roomOff": "Выключить",
    "roomOff_title": "Выключить режим комнаты — запись станет обычной голосовой заметкой",
    "roomRenameHint": "Нажмите на имя, чтобы переименовать — один из них вы.",
    "gateBodyRoom": "Записывайте всё, что говорят вокруг вас — с определением говорящих и извлечением задач. Входит в Pro.",
    "roomHintDevice": "Звонки на этом устройстве записать нельзя — iOS сохраняет их приватность. Другой телефон на громкой связи или разговор в комнате — можно.",
    "autoStoppedSize": "Запись остановлена на лимите размера загрузки.",
    "tooLarge": "Запись оказалась слишком большой для загрузки, поэтому расшифровать её не удалось.",
    "destTo": "В",
    "dest_aria": "Добавить в список: {{name}}",
    "destMenu_aria": "Выберите список",
    "destNewPending_aria": "Новый список: {{name}}"
  },
  "meetingNotice": {
    "title": "Встречи — в ваших заметках",
    "body": "Rhemn теперь может записывать выбранную вами вкладку встречи — только пока вы записываете голосовую заметку, и только ту вкладку, которую вы выбрали.",
    "factPrivacy": "Аудио обрабатывается для создания расшифровки и затем удаляется. Записи никогда не хранятся.",
    "factControl": "Ничего не записывается, пока вы не нажмёте запись и не выберете вкладку.",
    "cta": "Понятно",
    "privacyLink": "Прочитать политику конфиденциальности",
    "dialog_aria": "О новом разрешении на запись встреч"
  }
}
